import { render, staticRenderFns } from "./UyapAdliyePicker.vue?vue&type=template&id=468e1008"
import script from "./UyapAdliyePicker.vue?vue&type=script&lang=ts"
export * from "./UyapAdliyePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports